import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const META = {
  women: { title: "Women", sub: "Bikinis & One-Pieces, tailored to your body", banner: "https://images.unsplash.com/photo-1642472169780-6ff9b74a3058" },
  men: { title: "Men", sub: "Tailored trunks, cut to your measurements", banner: "https://images.unsplash.com/photo-1710488140847-c076d4e80cc8" },
  swimwear: { title: "All Swimwear", sub: "The complete SHIOKOI atelier", banner: "https://images.unsplash.com/photo-1564955731632-aae2940730ec" },
};

export default function Catalog({ gender }) {
  const params = useParams();
  const key = gender || "swimwear";
  const meta = META[key];
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const q = gender ? `?gender=${gender}` : "";
    api.get(`/products${q}`).then((r) => setProducts(r.data));
    setFilter("all");
  }, [gender, params]);

  const categories = ["all", ...Array.from(new Set(products.map((p) => p.category)))];
  const shown = filter === "all" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="catalog-page" className="pt-20">
      <section className="relative h-[46vh] min-h-[320px] overflow-hidden flex items-end">
        <img src={meta.banner} alt={meta.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-black/10" />
        <div className="relative max-w-[1400px] mx-auto w-full px-6 lg:px-10 pb-12">
          <h1 className="font-serif text-white text-5xl md:text-7xl font-light">{meta.title}</h1>
          <p className="text-white/85 mt-3">{meta.sub}</p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
        {categories.length > 2 && (
          <div className="flex gap-3 mb-10 flex-wrap">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c}`}
                onClick={() => setFilter(c)}
                className={`overline px-5 py-2 border transition-colors ${
                  filter === c ? "bg-ocean text-sand border-ocean" : "border-charcoal/25 hover:border-charcoal"
                }`}
              >
                {c === "all" ? "All" : c.split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")}
              </button>
            ))}
          </div>
        )}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
          {shown.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
        {shown.length === 0 && <p className="text-charcoal/50 py-20 text-center">No pieces here yet.</p>}
      </section>
    </div>
  );
}
